import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SimpleTextModalComponent } from './simple-text-modal.component';

@NgModule({
  imports: [CommonModule, MatDialogModule],
  exports: [SimpleTextModalComponent],
  declarations: [SimpleTextModalComponent],
  entryComponents: [SimpleTextModalComponent]
})
export class SimpleTextModalModule {}
